import { useEffect } from "react";
import Header from "../../ui-components/Header";
import Footer from "../../ui-components/Footer";
import { Typography, Box } from "@mui/material";
import AOS from "aos";
import "../Users/Welcome/style.scss";
import "./Agreement.scss";
import "aos/dist/aos.css";

const ChildSafetyStandards = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: false,
      mirror: true,
    });
  });
  return (
    <div className="welcome">
      <Header />

      <div className="container">
        <Box className="agreement">
          <Typography
            variant="h5"
            component="h1"
            gutterBottom
            data-aos="fade-up"
          >
            Pellifix Child Safety Standards
          </Typography>
          <Typography variant="subtitle2" component="p" data-aos="fade-up">
            At Pellifix, the safety of all users—especially children—is our top
            priority. Our app is intended for adults 18+, and we do not target
            children under 13. We are committed to preventing any form of child
            exploitation and ensuring a safe environment for our users.
          </Typography>

          <Typography
            variant="h6"
            component="h2"
            gutterBottom
            data-aos="fade-up"
          >
            1. Child Safety Policy
          </Typography>

          <Typography
            variant="subtitle2"
            component="p"
            data-aos="fade-up"
            pl={2}
          >
            Pellifix strictly prohibits any sexual content, abuse, or
            exploitation involving minors. <br />
            We do not knowingly collect data from children under 13.
            <br />
            All content uploaded to Pellifix is monitored, and inappropriate
            content will be removed immediately.
          </Typography>
          <Typography
            variant="h6"
            component="h2"
            gutterBottom
            data-aos="fade-up"
          >
            2. Reporting and Enforcement
          </Typography>
          <Typography
            variant="subtitle2"
            component="p"
            data-aos="fade-up"
            pl={2}
          >
            Users can report unsafe content or behavior directly through the
            app. <br />
            All reports are reviewed promptly by our moderation team.
            <br />
            Violations of our policies may result in account suspension or
            termination.
          </Typography>
          <Typography
            variant="h6"
            component="h2"
            gutterBottom
            data-aos="fade-up"
          >
            3. Data Collection
          </Typography>
          <Typography
            variant="subtitle2"
            component="p"
            data-aos="fade-up"
            pl={2}
          >
            We only collect data necessary for the app to function (e.g.,
            account email, profile info).
            <br />
            No data from children under 13 is collected.
            <br />
            Our Privacy Policy describes what data we collect and how it is
            used: <a href="/privacy-policy">Privacy Policy</a>
          </Typography>
          <Typography
            variant="h6"
            component="h2"
            gutterBottom
            data-aos="fade-up"
          >
            4. Education and Awareness
          </Typography>
          <Typography
            variant="subtitle2"
            component="p"
            data-aos="fade-up"
            pl={2}
          >
            We encourage all users to follow standard online safety practices.
            <br />
            We provide resources and reminders to protect personal information
            and avoid risky interactions.
          </Typography>
          <Typography
            variant="h6"
            component="h2"
            gutterBottom
            data-aos="fade-up"
          >
            5. Contact
          </Typography>
          <Typography
            variant="subtitle2"
            component="p"
            data-aos="fade-up"
            pl={2}
          >
            If you have questions about our child safety practices or need to
            report a concern, please contact us at:
            <br />
            Email: <a href="mailto:admin@pellifix.com">admin@pellifix.com</a>
            <br />
            Website:{" "}
            <a
              href="https://pellifix.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.pellifix.com
            </a>
          </Typography>
        </Box>
      </div>
      <Footer />
    </div>
  );
};
export default ChildSafetyStandards;
